import React from "react";
import {useBroadcastNotifications} from "./hooks";
import Notification from "./Notification";
import {Button} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import {Campaign, Delete} from "@mui/icons-material";
import VisibilityOff from "@mui/icons-material/VisibilityOff";


export default function Broadcasts() {
    const {notifications, isLoading} = useBroadcastNotifications();
    const [showAll, setShowAll] = React.useState(false);

    if (isLoading) {
        return null; // or a loading spinner
    }

    const visibleNotifications = notifications.filter(notification => notification.is_active_now && !notification.is_dismissed);
    const dismissedOrVisibleNotifications = notifications.filter(notification => notification.is_active_now)

    const hasMoreToShow = visibleNotifications.length < dismissedOrVisibleNotifications.length;

    if (dismissedOrVisibleNotifications.length === 0) {
        return null; // No visible notifications to display
    }
    const shownNotifications = showAll ? dismissedOrVisibleNotifications : visibleNotifications;

    if (shownNotifications.length === 0) {
        // if there are no active notifications but there are dismissed notifications
        // return null;
        return (
            <div className={"position-absolute"} style={{right: "1em"}}>
                <Button className="text-small" onClick={() => setShowAll(!showAll)}>
                    <Campaign className="me-2"/>
                </Button>
            </div>
        )
    }

    return (
        <div className="p-3 w-100 top-0 start-0" style={{zIndex: "1200"}}>
            <div className="bg-white border border-1 shadow rounded">
                {
                    shownNotifications.map((notification, index) =>
                        <Notification key={notification.id} notification={notification} allowMarkViewed/>
                    )
                }
                <div className={"text-end"}>
                    {
                        hasMoreToShow && <>
                            {
                                showAll ?
                                    <Button className="text-small" onClick={() => setShowAll(!showAll)}>
                                        <VisibilityOff className="me-2"/>
                                        HIDE DISMISSED
                                    </Button> :
                                    <Button className="text-small" onClick={() => setShowAll(!showAll)}>
                                        <Visibility className="me-2"/>
                                        SHOW ALL
                                    </Button>
                            }
                        </>
                    }


                </div>
            </div>
        </div>
    )
}